export function mainFeaturesScroll() {
  const section = document.querySelector('[data-main-features-section]');
  if (!section) return;

  const featureItems = section.querySelectorAll('.feature-item');
  const featureImages = section.querySelectorAll('.feature-image');

  if (featureItems.length === 0 || featureImages.length === 0) return;

  let activeIndex = 0;
  updateActiveFeature(featureItems, featureImages, activeIndex);

  const handleScroll = () => {
    let minDistance = Infinity;
    let newActiveIndex = activeIndex;

    featureItems.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const distanceFromTop = Math.abs(rect.top);
      const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;

      if (isVisible && distanceFromTop < minDistance) {
        minDistance = distanceFromTop;
        newActiveIndex = index;
      }
    });

    if (newActiveIndex !== activeIndex) {
      activeIndex = newActiveIndex;
      updateActiveFeature(featureItems, featureImages, activeIndex);
    }
  };

  let ticking = false;
  const throttledScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', throttledScroll, { passive: true });
  handleScroll();
}

function updateActiveFeature(featureItems, featureImages, activeIndex) {
  featureItems.forEach((item, index) => {
    if (index === activeIndex) {
      item.classList.remove('opacity-60');
    } else {
      item.classList.add('opacity-60');
    }
  });

  featureImages.forEach((image, index) => {
    if (index === activeIndex) {
      image.classList.remove('opacity-0');
      image.classList.add('opacity-100');
    } else {
      image.classList.remove('opacity-100');
      image.classList.add('opacity-0');
    }
  });
}
